import generateTypes from '../utils/generateTypes';

export const GET_SESSIONS = generateTypes('GET_SESSIONS');
export const RESET_SESSIONS = 'RESET_SESSIONS';
